import { Grid } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $StepsOrchestratorContainer = styled.div`
  position: relative;
  margin-left: ${spacing('lg')};
  margin-right: ${spacing('lg')};
`;

export const $Grid = styled(Grid)`
  @media ${media.maxWidth.xs} {
    width: 100%;
  }
`;
